import { render, staticRenderFns } from "./JoinAmbassadorsInsight.vue?vue&type=template&id=162e912e&scoped=true"
import script from "./JoinAmbassadorsInsight.vue?vue&type=script&lang=js"
export * from "./JoinAmbassadorsInsight.vue?vue&type=script&lang=js"
import style0 from "./JoinAmbassadorsInsight.vue?vue&type=style&index=0&id=162e912e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e912e",
  null
  
)

export default component.exports